import { type FC, useMemo } from 'react';

import type { JSONContent } from '@tiptap/core';
import cn from 'classnames';

import type { VideoPlaybackResolver, VideoStatusSubscriber } from '../types';
import { hasTiptapContent, type ImageSrcTransform, type SerializerOptions, serializeNode } from './serializer';

const identityImageSrc: ImageSrcTransform = (src) => src;

export interface CommunityContentRendererProps {
  tiptapState: JSONContent;
  className?: string;
  imageSrc?: ImageSrcTransform;
  videoPlayback?: VideoPlaybackResolver;
  videoStatus?: VideoStatusSubscriber;
  videoTranslations?: SerializerOptions['videoTranslations'];
  renderImage?: SerializerOptions['renderImage'];
  renderMentionLink?: SerializerOptions['renderMentionLink'];
  mentionFallbackLabel?: string;
}

export const CommunityContentRenderer: FC<CommunityContentRendererProps> = ({
  tiptapState,
  className,
  imageSrc = identityImageSrc,
  videoPlayback,
  videoStatus,
  videoTranslations,
  renderImage,
  renderMentionLink,
  mentionFallbackLabel,
}) => {
  const content = useMemo(() => {
    if (!hasTiptapContent(tiptapState)) return null;
    return serializeNode(tiptapState, 'ttp', {
      imageSrc,
      videoPlayback,
      videoStatus,
      videoTranslations,
      renderImage,
      renderMentionLink,
      mentionFallbackLabel,
    });
  }, [
    tiptapState,
    imageSrc,
    videoPlayback,
    videoStatus,
    videoTranslations,
    renderImage,
    renderMentionLink,
    mentionFallbackLabel,
  ]);

  if (!content) return null;

  return <div className={cn('text-black text-[15px] leading-6 break-words', className)}>{content}</div>;
};
